/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import Check from '@mui/icons-material/Check';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import Search from '@mui/icons-material/Search';

import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/defaultSelectComponents.module.scss';

// DROPDOWN INDICATOR

const DropdownIndicator = (props) => {
  let icon = props.selectProps.menuIsOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
  if (props.selectProps.isSearchable) icon = <Search />;

  return (
    <components.DropdownIndicator {...props}>
      {createIconComponent({
        icon,
        size: 18,
        className: props.isDisabled
          ? styles.dropdownIsDisabled
          : styles.dropdown,
      })}
    </components.DropdownIndicator>
  );
};

const GroupHeading = (props) => (
  <components.GroupHeading {...props}>
    <Typo color="secondary" element="span" variant="s01">
      {props.children}
    </Typo>
  </components.GroupHeading>
);

// INDICATOR SEPARATOR

const IndicatorSeparator = () => null;

// OPTION

const Option = (props) => (
  <components.Option {...props}>
    <Typo
      title={props.children}
      variant="b01"
      element="span"
      className={styles.optionText}
    >
      {props.children}
    </Typo>
    {props.isSelected && <Check sx={{ height: 18, width: 18 }} />}
  </components.Option>
);

// PLACEHOLDER

const Placeholder = (props) => (
  <components.Placeholder {...props}>
    <Typo variant="s03" className={styles.placeholderText} title={props.children}>{props.children}</Typo>
  </components.Placeholder>
);

// VALUES

// MULTI

const MultiValue = (props) => {
  const lastOption = props.selectProps.value[0] || props.selectProps.options[0];
  const lastOptionLabel = lastOption.label;
  const remainingOptionsCount = props.selectProps.value.length;
  const { value } = props.data;

  if (value !== lastOption.value) return null;

  return (
    <components.MultiValue {...props}>
      <Typo
        title={lastOptionLabel}
        variant="s02"
        weight={props.isFocused || props.hasValue ? 'medium' : ''}
      >
        {lastOptionLabel}
      </Typo>
      <Typo variant="s02">{`(+${remainingOptionsCount})`}</Typo>
    </components.MultiValue>
  );
};

MultiValue.propTypes = {
  selectProps: PropTypes.shape({
    value: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        label: PropTypes.string,
        value: PropTypes.any,
      }),
    ),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        label: PropTypes.string,
        value: PropTypes.any,
      }),
    ),
  }).isRequired,
  data: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
  isFocused: PropTypes.bool.isRequired,
  hasValue: PropTypes.bool.isRequired,
};

// NAVIGATOR SINGLE

const SingleValue = ({ isFocused = false, ...props }) => (
  <components.SingleValue isFocused={isFocused} {...props}>
    <Typo
      variant="s02"
      className={styles.singleValueText}
      title={props.children}
    >
      {props.children}
    </Typo>
  </components.SingleValue>
);

SingleValue.propTypes = {
  isFocused: PropTypes.bool,
  hasValue: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default {
  DropdownIndicator,
  GroupHeading,
  IndicatorSeparator,
  MultiValue,
  Option,
  Placeholder,
  SingleValue,
};
